import { QueryClient } from '@tanstack/react-query';

/**
 * Create a query client with default options
 */
export const createQueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Default stale time of 5 minutes
        staleTime: 5 * 60 * 1000,
        // Default cache time of 10 minutes
        gcTime: 10 * 60 * 1000,
        retry: 0,
        // Don't refetch on window focus in development
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
};

/**
 * Singleton instance of the query client
 */
export const queryClient = createQueryClient();
